export const Functions = {
    openWindow: (link, attr=null) => {
        window.open(link, attr);
    }
}